import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';

import { Pagination } from '@shared/pagination';
import { trackElement } from '@shared/utils';

@Component({
  selector: 'mojo-collection-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  animations: [
    trigger('insertRemoveTrigger', [
      transition(':enter', [
        style({
          opacity: 0,
          position: 'relative',
          top: 0,
        }),
        animate('500ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate(
          '350ms cubic-bezier(.57,.34,.6,.68)',
          style({
            opacity: 0,
            transform: 'scale(0.1)',
            height: 0,
            top: 80,
          }),
        ),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListComponent {
  @Input() items: {}[];
  @Input() pagination: Pagination<{}>;
  @Input() text: string;
  @Input() isTransparent = false;
  @Input() itemTemplate!: TemplateRef<any>;
  @Input() enableAnimation = false;

  trackElement = trackElement;
}
